// Copyright (c) 2026 GLOBAL MICRO IT TECHNOLOGY SOLUTIONS LIMITED
// Company No. 758762, Dublin, Ireland
// All rights reserved. Proprietary and confidential.

import { Button, Caption1, Tooltip } from '@fluentui/react-components';
import {
  ZoomInRegular,
  ZoomOutRegular,
  ArrowResetRegular,
} from '@fluentui/react-icons';
import { useIntl } from 'react-intl';
import type { ZoomState } from '../hooks/useAutoZoom';

interface ZoomControlProps {
  zoomState: ZoomState;
}

export const ZoomControl = ({ zoomState }: ZoomControlProps) => {
  const intl = useIntl();
  const { zoomPercent, mode, zoomIn, zoomOut, resetToAuto, canZoomIn, canZoomOut } = zoomState;

  return (
    <div className="zoom-control">
      <Tooltip
        content={intl.formatMessage({ id: 'zoom.out' })}
        relationship="label"
      >
        <Button
          appearance="transparent"
          size="small"
          icon={<ZoomOutRegular />}
          disabled={!canZoomOut}
          onClick={zoomOut}
        />
      </Tooltip>

      <Caption1 className="zoom-label">
        {zoomPercent}%
      </Caption1>

      <Tooltip
        content={intl.formatMessage({ id: 'zoom.in' })}
        relationship="label"
      >
        <Button
          appearance="transparent"
          size="small"
          icon={<ZoomInRegular />}
          disabled={!canZoomIn}
          onClick={zoomIn}
        />
      </Tooltip>

      <Tooltip
        content={intl.formatMessage({ id: 'zoom.reset' })}
        relationship="label"
      >
        <Button
          appearance="transparent"
          size="small"
          icon={<ArrowResetRegular />}
          onClick={resetToAuto}
          disabled={mode !== 'manual'}
          style={mode !== 'manual' ? { visibility: 'hidden' } : undefined}
          tabIndex={mode !== 'manual' ? -1 : undefined}
          aria-hidden={mode !== 'manual' ? true : undefined}
        />
      </Tooltip>
    </div>
  );
};
